import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { afterItems, beforeItems } from '../data/transformation';
export function ComparisonSection() {
  return <section aria-labelledby="comparison-title" className="bg-brand-alt px-4 py-20 md:py-28" data-id="element-36" data-mp="39e7opp9rorsw">
      <Reveal className="mx-auto max-w-content" data-id="element-37" data-mp="34g68rd7n18ln">
        <div className="mx-auto mb-12 max-w-3xl text-center" data-id="element-38" data-mp="34fedy4lv7ewf">
          <p className="mb-4 text-xs font-extrabold uppercase tracking-[0.18em] text-brand-teal" data-id="element-39" data-mp="2zgtkco14btgy">
            IL COSTO DI PARTIRE DA ZERO
          </p>
          <h2 id="comparison-title" className="text-3xl font-extrabold leading-[1.1] tracking-tight text-brand-primary md:text-4xl" data-id="element-40" data-mp="2vhcgfz1cb4dw">
            Ogni Lezione da Improvvisare, o Ogni Unità Già Pronta.
          </h2>
        </div>
        <div className="overflow-hidden rounded-[20px] border border-brand-sand bg-brand-alt shadow-[0_14px_40px_rgba(11,60,93,0.08)]" data-id="element-41" data-mp="on7cbu67ouhj">
          <div className="grid md:grid-cols-2" data-id="element-42" data-mp="jnmbfe7hec26">
            <Comparison eyebrow="IL VECCHIO MODO DI INSEGNARE MOTORIA" title="PRIMA" items={beforeItems} positive={false} data-id="element-43" data-mp="3ae1my88ovp33" />
            <Comparison eyebrow="IL CURRICOLO PRONTO ALL’USO" title="CON EDUCAZIONE FISICA PRONTA" items={afterItems} positive data-id="element-44" data-mp="30hqbfkgxb39p" />
          </div>
          <div className="border-t border-brand-sand bg-brand-cream px-6 py-4 text-center text-xs italic text-brand-gray" data-id="element-45" data-mp="3t6nierfopdn5">
            Un sistema motorio completo: prepari meno e insegni con più sicurezza.
          </div>
        </div>
      </Reveal>
    </section>;
}
interface ComparisonProps {
  eyebrow: string;
  title: string;
  items: string[];
  positive: boolean;
}
function Comparison({
  eyebrow,
  title,
  items,
  positive
}: ComparisonProps) {
  const Icon = positive ? CheckIcon : XIcon;
  return <div className={`p-6 md:p-9 ${positive ? 'bg-brand-cream md:border-l md:border-brand-sand' : 'bg-[#F4F5F6]'}`} data-id="element-46" data-mp="kqkk3cagp1bh">
      <div className="mb-7 flex items-start justify-between gap-4" data-id="element-47" data-mp="ukzv82j8ymhp">
        <div data-id="element-48" data-mp="pnpx7yhsl2i9">
          <p className={`text-[10px] font-extrabold uppercase tracking-[0.16em] ${positive ? 'text-brand-teal' : 'text-brand-gray'}`} data-id="element-49" data-mp="pnzn7m2u79ny">
            {eyebrow}
          </p>
          <h3 className="mt-2 font-display text-xl font-bold tracking-tight text-brand-primary md:text-2xl" data-id="element-50" data-mp="gl88ndenzxs3">
            {title}
          </h3>
        </div>
        <div className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-full ${positive ? 'bg-brand-teal text-white shadow-sm' : 'bg-white text-brand-gray'}`} data-id="element-51" data-mp="6wgmjlwac7p3">
          <Icon className="h-5 w-5" aria-hidden="true" data-id="element-52" data-mp="3t3ewum7azh8k" />
        </div>
      </div>
      <ul className="space-y-2.5" data-id="element-53" data-mp="3t1bxhbk9gbr6">
        {items.map(item => <li key={item} className="flex items-start gap-3 rounded-[16px] bg-white/70 px-3 py-3" data-id="element-54" data-mp="3p0i9ki6tiwya">
            <span className={`mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full ${positive ? 'bg-brand-teal/15 text-brand-teal' : 'bg-black/5 text-brand-gray'}`} data-id="element-55" data-mp="3k41j3hc5c6i1">
              <Icon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-56" data-mp="24i7ryu0z1eyp" />
            </span>
            <span className={`text-sm leading-snug ${positive ? 'font-semibold text-brand-text' : 'text-brand-gray'}`} data-id="element-57" data-mp="28mnuqmfag69p">
              {item}
            </span>
          </li>)}
      </ul>
    </div>;
}